__webpack_require__.p = "/reports-summary-style-adjustments/onboarding/";